module.exports = __webpack_public_path__ + "img/button_close_grey.daeecb1b.png";